var map = {
	"./1.jpg": 1546,
	"./10.jpg": 9978,
	"./11.jpg": 2310,
	"./12.jpg": 3666,
	"./13.jpg": 8472,
	"./2.jpg": 6641,
	"./3.jpg": 8479,
	"./4.jpg": 1180,
	"./5.jpg": 5844,
	"./6.jpg": 5625,
	"./7.jpg": 8548,
	"./8.jpg": 6411,
	"./9.jpg": 366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5580;